"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTooltipData = exports.getZoomInMinMaxY = exports.formatTooltipXAxisValue = exports.getSecondaryXAxisTickFormat = exports.getXAxisTickFormat = exports.yAxisTickFormat = void 0;
var tslib_1 = require("tslib");
var d3 = tslib_1.__importStar(require("d3"));
var pipe_1 = tslib_1.__importDefault(require("lodash/fp/pipe"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
var flatMap_1 = tslib_1.__importDefault(require("lodash/fp/flatMap"));
var filter_1 = tslib_1.__importDefault(require("lodash/fp/filter"));
var date_fns_1 = require("date-fns");
var chartUtils_1 = require("../chartUtils");
exports.yAxisTickFormat = function (d, precision) {
    return chartUtils_1.formatLinearNumbers(d, precision);
};
exports.getXAxisTickFormat = function (axisType, width, chartBreakPoints, ticks) {
    switch (axisType) {
        case 'MONTH':
            if (width <= chartBreakPoints.medium[0] && ticks.length > 2) {
                return function (d, i) {
                    return i % 2 === 0 ? chartUtils_1.formatMonths(d, i, ticks, 2) : '';
                };
            }
            return function (d, i) { return chartUtils_1.formatMonths(d, i, ticks, 1); };
        default:
            return function (d) { return d; };
    }
};
exports.getSecondaryXAxisTickFormat = function (axisType, width, chartBreakPoints, ticks) {
    switch (axisType) {
        case 'MONTH':
            if (width <= chartBreakPoints.medium[0] && ticks.length > 2) {
                return function (d, i) {
                    return i % 2 === 0 ? chartUtils_1.formatYears(d, i, ticks, 2) : '';
                };
            }
            return function (d, i) { return chartUtils_1.formatYears(d, i, ticks, 1); };
        default:
            return undefined;
    }
};
exports.formatTooltipXAxisValue = function (axisType, value) {
    switch (axisType) {
        case 'MONTH':
            return d3.timeFormat('%b %Y')(value);
        default:
            return chartUtils_1.formatLinearNumbers(value);
    }
};
exports.getZoomInMinMaxY = function (xScaleGroup, yScaleLine, yScaleBar, data, chartWidth) {
    var lineDataInZoom = pipe_1.default(flatMap_1.default(get_1.default('values')), filter_1.default(function (v) { return xScaleGroup(v.x) >= 0 && xScaleGroup(v.x) <= chartWidth; }))(data.lineData);
    var barDataInZoom = pipe_1.default(filter_1.default(function (group) {
        return xScaleGroup(group.group) >= 0 && xScaleGroup(group.group) <= chartWidth;
    }), flatMap_1.default(get_1.default('values')))(data.barData.groupedData);
    var minYBarVal = d3.min(barDataInZoom, function (d) { return d.y; });
    var minYBarPixelVal = yScaleBar(minYBarVal > 0 ? 0 : minYBarVal);
    var maxYBarPixelVal = yScaleBar(d3.max(barDataInZoom, function (d) { return d.y; }));
    var minYLinePixelVal = yScaleLine(d3.min(lineDataInZoom, function (d) { return d.y; }));
    var maxYLinePixelVal = yScaleLine(d3.max(lineDataInZoom, function (d) { return d.y; }));
    var minYPixelVal = minYBarPixelVal > minYLinePixelVal ? minYBarPixelVal : minYLinePixelVal;
    var maxYPixelVal = maxYBarPixelVal < maxYLinePixelVal ? maxYBarPixelVal : maxYLinePixelVal;
    return {
        minYLine: yScaleLine.invert(minYPixelVal),
        maxYLine: yScaleLine.invert(maxYPixelVal),
        minYBar: yScaleBar.invert(minYPixelVal),
        maxYBar: yScaleBar.invert(maxYPixelVal),
    };
};
exports.getTooltipData = function (data, group) {
    return data.barData.subGroups.map(function (subgroup) {
        var barValue = group.values.find(function (v) { return v.subGroupID === subgroup.ID; });
        var dataForSameSubgroup = data.lineData.find(function (v) { return v.ID === subgroup.ID; });
        var lineValue = (dataForSameSubgroup || { values: [] }).values.find(function (v) {
            return date_fns_1.isSameDay(v.x, group.group);
        });
        return tslib_1.__assign(tslib_1.__assign({}, subgroup), { barValue: barValue, lineValue: lineValue });
    });
};
